module.exports = __webpack_public_path__ + "img/video.aa49fb22.svg";